import { OnboardingStatus, TrayOnboardingStatus } from './SatoResponses';

export enum VideoType {
  EMPTY_TRAY = 'empty-tray',
  IN_TRAY_COMPLETE = 'in-tray-complete',
  IN_TRAY_INCOMPLETE = 'in-tray-incomplete',
  OUTISDE_TRAY = 'outside-tray',
  IN_TRAY_SHUFFLED = 'in-tray-shuffled',
  ADDITIONAL = 'additional',
}

export interface TrayResponse {
  tray_ref: string;
  tray_id: string;
  tray_image: string;
  tray_description: string;
}

export interface TrayVideo {
  status: OnboardingStatus;
  url: string;
  type: VideoType;
  order: number;
  converted_url?: string;
  crop_start?: number;
  crop_end?: number;
}

export type UpdateTrayVideo = Partial<TrayVideo> & Pick<TrayVideo, 'order' | 'type'>;

export interface DraftTrayResponse {
  comments: string[];
  tray_ref: string;
  tray_id: string;
  tray_image: string;
  tray_description: string;
  status: TrayOnboardingStatus;
  videos: TrayVideo[];
}
